import axios from 'axios';

export default {
    fetchAll() {
        return axios.get('[API]/productlist-definition/list');
    },
};
